function M(e) {
  const s = e.regex, n = [
    "div",
    "mod",
    "in",
    "and",
    "or",
    "not",
    "xor",
    "asserterror",
    "begin",
    "case",
    "do",
    "downto",
    "else",
    "end",
    "exit",
    "for",
    "local",
    "if",
    "of",
    "repeat",
    "then",
    "to",
    "until",
    "while",
    "with",
    "var"
  ], a = "false true", r = [
    e.C_LINE_COMMENT_MODE,
    e.COMMENT(
      /\{/,
      /\}/,
      { relevance: 0 }
    ),
    e.COMMENT(
      /\(\*/,
      /\*\)/,
      { relevance: 10 }
    )
  ], t = {
    className: "string",
    begin: /'/,
    end: /'/,
    contains: [{ begin: /''/ }]
  }, o = {
    className: "string",
    begin: /(#\d+)+/
  }, c = {
    className: "number",
    begin: "\\b\\d+(\\.\\d+)?(DT|D|T)",
    relevance: 0
  }, i = {
    className: "string",
    // not a string technically but makes sense to be highlighted in the same style
    begin: '"',
    end: '"'
  }, E = {
    match: [
      /procedure/,
      /\s+/,
      /[a-zA-Z_][\w@]*/,
      /\s*/
    ],
    scope: {
      1: "keyword",
      3: "title.function"
    },
    contains: [
      {
        className: "params",
        begin: /\(/,
        end: /\)/,
        keywords: n,
        contains: [
          t,
          o,
          e.NUMBER_MODE
        ]
      },
      ...r
    ]
  }, d = [
    "Table",
    "Form",
    "Report",
    "Dataport",
    "Codeunit",
    "XMLport",
    "MenuSuite",
    "Page",
    "Query"
  ], l = {
    match: [
      /OBJECT/,
      /\s+/,
      s.either(...d),
      /\s+/,
      /\d+/,
      /\s+(?=[^\s])/,
      /.*/,
      /$/
    ],
    relevance: 3,
    scope: {
      1: "keyword",
      3: "type",
      5: "number",
      7: "title"
    }
  };
  return {
    name: "C/AL",
    case_insensitive: !0,
    keywords: {
      keyword: n,
      literal: a
    },
    illegal: /\/\*/,
    contains: [
      {
        match: /[\w]+(?=\=)/,
        scope: "attribute",
        relevance: 0
      },
      t,
      o,
      c,
      i,
      e.NUMBER_MODE,
      l,
      E
    ]
  };
}
export {
  M as default
};
